import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const linkToFile = async (link: string): Promise<File | undefined> => {
  const url = new URL(link)

  try {
    const blob: Blob = await fetch(url?.href, {
      method: 'GET',
    }).then(r => r.blob())

    const fileName = url?.href?.split('/').slice(-1)[0]
    const file = new File([blob], fileName, {
      type: blob.type,
    })

    return file
  } catch (error) {
    toast({
      title: 'Error',
      description: error.message,
      status: 'error',
    })
  }
}
